import styled from 'styled-components';
import { Button as SemanticButton, Input as SemanticInput } from 'semantic-ui-react';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Button = styled(SemanticButton)`
    &.ui.button {
        color: ${(props) => props.theme.color.button};
        padding: 0;
        margin: 0;
        background-color: transparent;
        align-self: end;
    }
`;

const Container = styled.div`
    width: 250px;
    display: flex;
    flex-direction: column;
    padding: 10px;
    gap: 7px;
    align-items: center;
`;

const Input = styled(SemanticInput)`
    &.ui.input {
      width: 100%;
`;

const Label = styled(TextLayoutComponent)``;

export {
  Button,
  Container,
  Label,
  Input,
};
